module.exports = __webpack_public_path__ + "static/media/home-bg2-1.cc7bb539.png";